/* HeyBear · Product Imagine: "Imagine <classic lolly>… with protein" + lolly-vs-bear compare slider. */
HB.section('product-imagine', function (root) {
  var $ = function (s) { return root.querySelector(s); }, off = [];
  var cmp = $('#cmp'), r = $('#cmpR'), classic = $('#cmpL'), bear = $('#cmpB');
  var syncClassicHeight = function () {
    var height = bear.getBoundingClientRect().height;
    if (height) cmp.style.setProperty('--bear-height', height + 'px');
  };
  bear.addEventListener('load', syncClassicHeight);
  window.addEventListener('resize', syncClassicHeight);
  off.push(function () {
    bear.removeEventListener('load', syncClassicHeight);
    window.removeEventListener('resize', syncClassicHeight);
  });
  var onIn = function () { cmp.style.setProperty('--pos', r.value + '%'); };
  r.addEventListener('input', onIn); off.push(function () { r.removeEventListener('input', onIn); });
  function sweep() {
    if (HB.reduce) return;
    var t0 = performance.now(), path = [50, 80, 20, 50];
    (function st(now) {
      var p = Math.min(1, (now - t0) / 2000), s = Math.min(2, Math.floor(p * 3)), l = p * 3 - s, e = l < .5 ? 2 * l * l : 1 - Math.pow(-2 * l + 2, 2) / 2, v = path[s] + (path[s + 1] - path[s]) * e;
      cmp.style.setProperty('--pos', v + '%'); r.value = v; if (p < 1) requestAnimationFrame(st);
    })(t0);
  }
  var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) sweep(); }, { threshold: .5 }); io.observe(cmp);
  off.push(function () { io.disconnect(); });
  off.push(HB.pdp.on(function (k, f) {
    if (!f) return;
    $('#imWord').textContent = HB.pdp.word(f); $('#imCopy').textContent = f.im || '';
    bear.src = f.gummy; bear.alt = f.name + ' HeyBear gummy';
    if (bear.complete) requestAnimationFrame(syncClassicHeight);
    HB.lolly(k).then(function (svg) {
      if (HB.pdp.current() !== k) return;
      classic.innerHTML = svg;
      requestAnimationFrame(syncClassicHeight);
    });
  }));
  requestAnimationFrame(syncClassicHeight);
  return function () { off.forEach(function (fn) { fn(); }); };
});
